export const AuthVectorHeader = () => (
    <h1 className="flex-shrink-0 text-4xl xl:text-5xl 2xl:text-[3.5rem] 3xl:text-7xl align-middle font-thin whitespace-pre-line">
        {`Your eyes, our \n expertise`}
    </h1>
)
